import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import { SimpleGallery, Uploader } from '../uploads'
import settings from '../settings'
import features from '../../../../config/magnet/features'
import { allowedExtensions } from '../../../utils/cloudinary'
import QrUpload from '../qr-upload/QrUpload'
import useTranslation from '../../../utils/translation'

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: ${theme('photoUpload.section.borderBottom')};
  padding: 0px;
  border: 1px dotted rgba(0, 0, 0, 0.2);
  border-width: 2px;
  border-radius: 3px;

  ${(props) => props.theme.media.min.md`
    flex-direction: row;
  `}
`

const Right = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: 0px;
  ${(props) => props.theme.media.min.md`
    min-width: 100%;
  `}
  ${(props) => props.theme.media.min.lg`
    margin-top: 0;
  `}
  > * {
    flex-basis: 100%;
    ${(props) => props.theme.media.min.md`
    flex-basis: ${features.showQrCodeVideoUpload ? '50%' : '100%'};
  `}
  }
`
const QrCodeWrap = styled.div`
  display: none;
  ${(props) => props.theme.media.min.md`
    display: block;
  `}
`
const UploadContainer = styled.div`
  min-width: 115px;
  padding: ${theme('photoUpload.container.padding')};
  padding: 30px;
  border-right: none;
  ${(props) => props.theme.media.min.md`
    border-right: ${
      features.showQrCodeVideoUpload ? '1px dotted rgba(0, 0, 0, 0.2)' : 'none'
    };
    border-width: 2px;
  `}

  label {
    padding: ${theme('photoUpload.button.padding')};
    color: ${theme('photoUpload.button.color')};
    font-size: ${theme('photoUpload.button.fontSize')};
    letter-spacing: ${theme('photoUpload.button.letterSpacing')};
    border: ${theme('photoUpload.button.border')};
    background-color: ${theme('photoUpload.button.backgroundColor')};
    font-weight: 500;
    border-radius: 3px;
    &:before {
      color: ${theme('photoUpload.button.color')};
      background-color: ${theme('photoUpload.button.backgroundColor')};
      border: ${theme('photoUpload.button.border')};
      height: ${theme('photoUpload.button.height')};
    }

    &:not([disabled]):hover {
      color: ${theme('photoUpload.buttonHover.color')};

      &:before {
        color: ${theme('photoUpload.buttonHover.color')};
        background-color: ${theme('photoUpload.buttonHover.backgroundColor')};
        border: ${theme('photoUpload.buttonHover.border')};
      }
    }
  }
  ${(props) => props.theme.media.min.md`
    margin-left: ${theme('photoUpload.container.marginLeft')};
  `}
  ${(props) => props.theme.media.min.md`
  `}
`

const UploadHeading = styled.h5`
  font-size: 14px;
  font-weight: 500;
  margin-block-start: 0em;
  margin-block-end: 0em;
  line-height: 18px;
  padding-bottom: 12px;
`

const UploadPcHeading = styled(UploadHeading)`
  display: none;

  ${(props) => props.theme.media.min.md`
  display: block;
`}
`

const UploadMobileHeading = styled(UploadHeading)`
  display: block;

  ${(props) => props.theme.media.min.md`
    display: none;
  `}
`

const OrCircle = styled.div`
  background-color: #f0ded0;
  font-size: 12px;
  line-height: 18px;
  min-width: 40px;
  padding: 11px 5px;
  border-radius: 50px;
  position: absolute;
  left: 50%;
  top: 49%;
  transform: translate(-50%, -50%);
  display: none;
  ${(props) => props.theme.media.min.md`
    display: block;
  `}
`
const PhotoQrUpload = ({ fileInputId, qrBlockId, onChange, uploadedFiles }) => {
  const t = useTranslation('app.prep-form')

  return (
    <SectionWrapper>
      <Right>
        <UploadContainer data-track="upload-container">
          <UploadPcHeading>{t('upload-from-computer')}</UploadPcHeading>
          <UploadMobileHeading>{t('upload-from-phone')}</UploadMobileHeading>
          {features.showQrCodeVideoUpload && (
            <OrCircle>{t('or').toLocaleUpperCase()}</OrCircle>
          )}
          <Uploader
            {...settings.uploads}
            userId="bada"
            handleChange={onChange}
            initialFiles={uploadedFiles}
            allowedExtensions={allowedExtensions}
            render={(uploaderProps) => (
              <SimpleGallery
                {...uploaderProps}
                fileInputId={fileInputId}
                fileInputText={t('button-browse')}
              />
            )}
          />
        </UploadContainer>
        {features.showQrCodeVideoUpload && (
          <QrCodeWrap>
            <QrUpload qrBlockId={qrBlockId} />
          </QrCodeWrap>
        )}
      </Right>
    </SectionWrapper>
  )
}

PhotoQrUpload.propTypes = {
  qrBlockId: PropTypes.string.isRequired,
  fileInputId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  uploadedFiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default PhotoQrUpload
